interface ToolbarConfig {
  [key: string]: {
    topBtnList: Array<{
      name: string;
    }>;
    bottomBtnList: Array<{
      name: string;
    }>;
  };
}

export const TOOLBAR_CONFIG: ToolbarConfig = {
  '/digital-base': {
    topBtnList: [{ name: 'AddressSearch' }, { name: 'LngLatLocate' }],
    bottomBtnList: [{ name: 'BanFlyZone' }, { name: 'Change23D' }],
  },
  '/grid-management': {
    topBtnList: [{ name: 'AddressSearch' }, { name: 'LngLatLocate' }],
    bottomBtnList: [{ name: 'Layer' }, { name: 'BanFlyZone' }, { name: 'Change23D' }],
  },
  '/flight-navigation': {
    topBtnList: [{ name: 'AddressSearch' }, { name: 'LngLatLocate' }],
    bottomBtnList: [{ name: 'Layer' }, { name: 'BanFlyZone' }, { name: 'Change23D' }],
  },
  '/road-network': {
    topBtnList: [{ name: 'AddressSearch' }, { name: 'LngLatLocate' }],
    bottomBtnList: [{ name: 'Layer' }, { name: 'BanFlyZone' }, { name: 'Change23D' }],
  },
  '/apply-fly': {
    topBtnList: [{ name: 'AddressSearch' }, { name: 'LngLatLocate' }],
    bottomBtnList: [{ name: 'Layer' }, { name: 'BanFlyZone' }, { name: 'Change23D' }],
  },
  '/home': {
    topBtnList: [{ name: 'AddressSearch' }, { name: 'LngLatLocate' }],
    bottomBtnList: [{ name: 'BanFlyZone' }, { name: 'Change23D' }],
  },
  '/detect': {
    topBtnList: [{ name: 'AddressSearch' }, { name: 'LngLatLocate' }],
    bottomBtnList: [{ name: 'Change23D' }, { name: 'Layer' }],
  },
};
